<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Button
              class="top_search_btn"
              type="primary"
              ghost
              icon="ios-funnel"
              @click="searchStatus = true"
            >高级搜索</Button>
            <Input
              class="search-ipt"
              type="text"
              v-model="keyword"
              placeholder="请输入方案名称"
              @on-enter
              clearable
            />
            <Button type="primary" icon="md-search" class="search_tn" @click="getConfigList">搜索</Button>
            <Button
              class="top_search_btn"
              type="primary"
              icon="md-add"
              @click="addEditorFlag = true"
            >新增</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row, index}" slot="subject">
          <span>{{row.subject != 0 ? row.subject:'所有'}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="monopoly">
          <span>{{row.monopoly ?'是':'否'}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="defaultFlag">
          <span>{{row.defaultFlag ?'内置':'自定义'}}</span>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <a class="jump_color" @click="editorItem(row)">编辑</a>
          <a class="jump_color" @click="showDeleteModal(row)">删除</a>
        </template>
      </Table>
    </div>
    <Modal
      v-model="deleteModalStatus"
      width="350"
      title="提示"
      @on-ok="deleteConfigItem"
      @on-cancel="deleteCancel"
    >
      <p style="font-size:20px;">确定删除“{{currentTitle}}”？</p>
    </Modal>
    <Modal
      v-model="addEditorFlag"
      width="550"
      title="新增/编辑"
      @on-ok="AddEditorConfirm"
      @on-cancel="AddEditorCancel"
    >
      <div class="modal_item_wrapper">
        <span class="modal_label">名称</span>
        <Input class="item_context" v-model="configName" />
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">科目</span>
        <Select v-model="subject" class="item_context">
          <Option v-for="item in subjectType" :value="item.name" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">题型</span>
        <Select v-model="questionType" class="item_context">
          <Option
            v-for="item in questionTypeListSelect"
            :value="item.id"
            :key="item.id"
          >{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">答案类型</span>
        <Select v-model="answerCondition" class="item_context">
          <Option v-for="item in answerConditionType" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">识别处理</span>
        <Select v-model="resultOperation" class="item_context" multiple>
          <Option v-for="item in resultOperationType" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">判断规则</span>
        <Select v-model="compareCondition" class="item_context" multiple>
          <Option v-for="item in compareConditionType" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">使用库</span>
        <Select v-model="msResources" class="item_context">
          <Option v-for="item in customResourcesType" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">优先级</span>
        <Select v-model="priority" class="item_context">
          <Option v-for="item in 5" :value="item" :key="item">{{item}}</Option>
        </Select>
      </div>
      <div class="modal_item_wrapper">
        <span class="modal_label">独占</span>
        <i-switch class="item_content_switch" size="large" v-model="monopoly">
          <span slot="open">开</span>
          <span slot="close">关</span>
        </i-switch>
      </div>
    </Modal>
    <Modal class v-model="searchStatus" width="300" title="高级搜索">
      <Input
        class="search-ipt"
        type="text"
        v-model="searchData.subject"
        placeholder="请输入科目"
        clearable
      />
      <Select v-model="searchData.question" style="width:100%; margin-top: 20px;">
        <Option v-for="item in questionTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="searchStatus = false">取消</Button>
        <Button class="add_record_btn" type="primary" icon="md-search" @click="sarchFn">高级搜索</Button>
      </div>
    </Modal>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getConfigList"></paging>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import paging from "../templates/Paging.vue";
import { alertTips, dealDate } from "../common/common";
import {
  _getConfigList,
  _getBasicsConfigInfo,
  _holdParamsConfig,
  _getQuestionTypeList,
  _deleteConfigItem
} from "../api/api";

export default {
  components: { draggable, paging },
  data() {
    return {
      searchData: {
        question: "",
        subject: ""
      }, //高级搜索
      pageSize: 10, // 每页条数
      currentNum: 1, // 当前页码
      totalNum: 0, // 数据总条数
      keyword: "", // 搜索内容
      basicsConfigList: {}, // 配置项
      addEditorFlag: false, // 新增、编辑状态
      deleteModalStatus: false, // 删除Modal状态
      currentTitle: "", // 当前要删除的规则标题
      answerConditionType: [], // 答案条件类型
      resultOperationType: [], // 结果处理类型
      compareConditionType: [], // 判断条件类型
      customResourcesType: [], // 自定义库资源
      subjectType: [], // 科目类型
      questionTypeList: [], //题型列表
      questionTypeListSelect: [], //题型列表
      answerCondition: "", // 答案条件类型
      resultOperation: "", // 结果处理类型
      compareCondition: "", // 判断条件类型
      customResources: "", // 自定义库资源
      subject: "", // 科目类型
      questionType: "", // 题型
      priority: "", // 优先级
      configName: "", // 名称
      selectedId: 0, // 当前操作的id
      monopoly: false, // 是否独占
      msResources: "", //选择的使用库
      searchStatus: false, //高级搜索弹出框
      tableHeader: [
        {
          title: "名称",
          key: "parameterName"
        },
        {
          title: "题型",
          key: "questionTypeTitle"
        },
        {
          title: "科目",
          key: "subject",
          slot: "subject"
        },
        {
          title: "识别库",
          key: "msResourcesTitle"
        },
        {
          title: "识别结果处理",
          key: "resultHandleTitle"
        },
        {
          title: "判断规则",
          key: "decideHandleTitle"
        },
        {
          title: "答案类型",
          key: "answerType"
        },
        {
          title: "独占",
          key: "monopoly",
          slot: "monopoly"
        },
        {
          title: "优先级",
          key: "priority"
        },
        {
          title: "更新时间",
          key: "updateTime"
        },
        {
          title: "默认",
          key: "defaultFlag",
          slot: "defaultFlag"
        },
        {
          title: "操作",
          slot: "action",
          width: 120
        }
      ],
      tableData: [
        {
          id: 125,
          title: "测试规则1",
          updateTime: "2019-08-29"
        }
      ]
    };
  },
  methods: {
    //    获取测试配置基础参数
    getBasicsConfigInfo() {
      const self = this;
      _getBasicsConfigInfo().then(res => {
        if (res.code === 0) {
          for (let key in res.data) {
            switch (key) {
              case "answerConditionType":
                self.answerConditionType = res.data[key];
                break;
              case "resultOperationType":
                self.resultOperationType = res.data[key];
                break;
              case "compareConditionType":
                self.compareConditionType = res.data[key];
                break;
              case "customResourcesType":
                self.customResourcesType = res.data[key];
                break;
              case "subjectType":
                self.subjectType = res.data[key];
                self.subjectType.unshift({ id: 0, name: "所有" });
                break;
            }
          }
          self.getQuestionTypeList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    // 获取配置列表
    getConfigList(msg) {
      const self = this;
      self.currentNum =
        typeof msg === "object" && msg.pageNum ? msg.pageNum : 1;
      let paramsInfo = {
        questionType: self.searchData.question,
        subject: self.searchData.subject,
        page: self.currentNum - 1,
        size: self.pageSize,
        sort: "updateTime,desc"
      };
      _getConfigList({ params: paramsInfo }).then(res => {
        if (res.code === 0) {
          res.data.content.forEach(item => {
            let dealResultArr = item.resultHandle
              ? item.resultHandle.split(",")
              : "";
            let receiveResultArr = [];
            let dealDecideArr = item.decideHandle
              ? item.decideHandle.split(",")
              : "";
            let receiveDecideArr = [];
            item.updateTime = dealDate(item.updateTime);
            self.answerConditionType.some((list, typeIndex) => {
              if (item.answerConditionHandle === list.id) {
                item.answerType = list.name;
              }
            });
            self.questionTypeList.some((list, typeIndex) => {
              if (item.questionType === list.id) {
                item.questionTypeTitle = list.name;
              }
            });
            self.customResourcesType.some((list, typeIndex) => {
              if (item.msResources == list.id) {
                item.msResourcesTitle = list.name;
              }
            });
            if (dealResultArr) {
              self.resultOperationType.forEach((list, typeIndex) => {
                //
                dealResultArr.forEach(item => {
                  if (item == list.id) {
                    receiveResultArr.push(list.name);
                  }
                });
              });
              item.resultHandleTitle = receiveResultArr.join(",");
            }
            if (dealDecideArr) {
              self.compareConditionType.forEach((list, typeIndex) => {
                dealDecideArr.forEach(item => {
                  if (item == list.id) {
                    receiveDecideArr.push(list.name);
                  }
                });
              });
              item.decideHandleTitle = receiveDecideArr.join(",");
            }
          });
          self.tableData = res.data.content;
          self.totalNum = res.data.total;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //      编辑某项
    editorItem(row) {
      if (row.defaultFlag) {
        alertTips("warning", "内置配置不可修改");
      } else {
        this.selectedId = row.id;
        this.configName = row.parameterName;
        this.subject = row.subject;
        this.questionType = row.questionType;
        this.answerCondition = row.answerConditionHandle;
        this.priority = row.priority;
        this.resultOperation = row.resultHandle
          ? row.resultHandle.split(",").map(item => Number(item))
          : "";
        this.compareCondition = row.decideHandle
          ? row.decideHandle.split(",").map(item => Number(item))
          : "";
        this.msResources = parseInt(row.msResources);
        this.monopoly = row.monopoly ? true : false;
        this.addEditorFlag = true;
      }
    },
    // 获取题目类型列表
    getQuestionTypeList() {
      const self = this;
      _getQuestionTypeList().then(res => {
        if (res.code === 0) {
          self.questionTypeList = res.data;
          self.questionTypeListSelect = res.data.unshift({
            id: "",
            name: "全部"
          });
          self.getConfigList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //     新增、编辑确认
    AddEditorConfirm() {
      const self = this;
      let dataInfo = {
        id: self.selectedId,
        parameterName: self.configName,
        subject: self.subject,
        questionType: self.questionType,
        answerConditionHandle: self.answerCondition,
        priority: self.priority,
        monopoly: self.monopoly ? 1 : 0,
        msResources: self.msResources,
        resultHandle: self.resultOperation
          ? self.resultOperation.join(",")
          : "",
        decideHandle: self.compareCondition
          ? self.compareCondition.join(",")
          : ""
      };
      _holdParamsConfig(dataInfo).then(res => {
        if (res.code === 0) {
          self.selectedId = 0;
          self.configName = "";
          self.subject = "";
          self.questionType = "";
          self.answerCondition = "";
          self.priority = "";
          self.msResources = "";
          self.monopoly = false;
          self.resultOperation = "";
          self.compareCondition = "";
          self.getConfigList();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    sarchFn() {
      //高级搜索
      this.getConfigList();
      this.searchStatus = false;
    },
    //     新增、编辑取消
    AddEditorCancel() {
      this.addEditorFlag = false;
      this.selectedId = 0;
      this.configName = "";
      this.subject = "";
      this.questionType = "";
      this.answerCondition = "";
      this.priority = "";
      this.msResources = "";
      this.monopoly = false;
      this.resultOperation = "";
      this.compareCondition = "";
    },
    //    删除Modal显示
    showDeleteModal(row) {
      this.selectedId = row.id;
      this.currentTitle = row.parameterName;
      this.deleteModalStatus = true;
    },
    //    删除确认
    deleteConfigItem() {
      const self = this;
      _deleteConfigItem(self.selectedId).then(res => {
        if (res.code === 0) {
          self.getBasicsConfigInfo();
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //    删除取消
    deleteCancel() {
      this.selectedId = 0;
      this.currentTitle = "";
    }
  },
  mounted() {
    //      先基础配置列表--》 题目类型类别--》 参数配置列表
    this.getBasicsConfigInfo();
  }
};
</script>
<style>
.item_content_switch {
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/OCRConfig.vue